import React from "react";
import "./Techstacks.css";
import { FaReact, FaNodeJs } from "react-icons/fa";
import {
  SiJava,
  SiRedux,
  SiHtml5,
  SiChakraui,
  SiMaterialui,
  SiExpress,
  SiRedis,
  SiTailwindcss,
  SiNetlify,
  SiStyledcomponents,
  SiJson,
  SiGit,
  SiGithub,
  SiNpm,
  SiVsco,
  SiVisualstudiocode,
  SiReplit,
  SiCodesandbox,
  SiCodepen,
  SiPostman,
  SiCanva,
  SiVercel,
  SiHeroku,
  SiYarn,
  SiNotion,
  SiAtlassian,
} from "react-icons/si";
import { DiCss3, DiMongodb } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
// import { SiJava } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap } from "react-icons/bs";
export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different">Skills</h2>
        <div className="techsection">
          <div>
            <SiJavascript/>
            <h5>Javascript</h5>
          </div>
          <div>
            <SiJava />
            <h5>Java</h5>
          </div>
          <div>
            <SiHtml5 />
            <h5>HTML 5</h5>
          </div>
          <div>
            <DiCss3 />
            <h5>CSS 3</h5>
          </div>
          <div>
            <FaReact />
            <h5>React</h5>
          </div>
          <div>
            <SiRedux />
            <h5>Redux</h5>
          </div>
          <div>
            <FaNodeJs />
            <h5>Nodejs</h5>
          </div>
          <div>
            <DiMongodb />
            <h5>MongoDb</h5>
          </div>
          <div>
            <SiExpress />
            <h5>Express</h5>
          </div>
          <div>
            <SiJson />
            <h5>JSON-server</h5>
          </div>
          <div>
            <SiChakraui />
            <h5>Chakra-UI</h5>
          </div>
          <div>
            <SiMaterialui />
            <h5>Material-UI</h5>
          </div>
          <div className="section10">
            <SiStyledcomponents />
            <h5>Styled-Com..</h5>
          </div>
          <div className="section11">
            <BsBootstrap />
            <h5>Bootstrap</h5>
          </div>
          </div>
        <div className="section main" data-aos="fade-right">
        <h2 className="section__title different1">Tools | Use</h2>
        <div className="techsection">
          <div>
            <SiGit />
            <h5>Git</h5>
          </div>
          <div>
            <SiGithub />
            <h5>GitHub</h5>
          </div>
          <div>
            <SiNetlify />
            <h5>Netlify</h5>
          </div>
          <div>
            <SiNpm />
            <h5>NPM</h5>
          </div>
          <div>
            <SiVisualstudiocode />
            <h5>VS Code</h5>
          </div>
          <div>
            <SiReplit />
            <h5>Replit</h5>
          </div>
          <div>
            <SiCodesandbox />
            <h5>Codesandbox</h5>
          </div>
          <div>
            <SiCodepen />
            <h5>Codepen</h5>
          </div>
          <div>
            <SiPostman />
            <h5>Postman</h5>
          </div>
          <div>
            <SiCanva />
            <h5>Canva</h5>
          </div>
          <div>
            <SiVercel />
            <h5>Vercel</h5>
          </div>
          <div>
            <SiHeroku />
            <h5>Heroku</h5>
          </div>
          <div className="section10">
            <SiYarn />
            <h5>Yarn</h5>
          </div>
          <div className="section11">
            <SiNotion />
            <h5>Notion</h5>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};
